// extracted by mini-css-extract-plugin
module.exports = {"input":"MinerAddress_input__7QPMJ"};